import {
    Component,
    ComponentFactoryResolver,
    OnInit,
    ViewChild,
    ViewContainerRef,
    ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScriptLoaderService } from '../_services/script-loader.service';
import { AuthenticationService } from './_services/authentication.service';
import { Helpers } from '../helpers';

@Component({
    selector: '',
    templateUrl: './templates/forgot.component.html',
    styleUrls: ['./templates/login-1.component.css'],
    encapsulation: ViewEncapsulation.None,
})

export class forgotComponent implements OnInit {
    model: any = {};
    loading = false;
    error = '';
    istrue = false;
    isrequest = false
    // returnUrl: '/portfolio';

    constructor(
        private _router: Router,
        private _script: ScriptLoaderService,
        // private _userService: UserService,
        private _route: ActivatedRoute,
        private _authService: AuthenticationService,
        // private _alertService: AlertService,
        private cfr: ComponentFactoryResolver) {
    }
    ngOnInit() {
        this.istrue = true;

        // this.model.remember = true;
        // this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
        // this._router.navigate([this.returnUrl]);

        // this._script.loadScripts('body', [
        //     'assets/vendors/base/vendors.bundle.js',
        //     'assets/demo/demo10/base/scripts.bundle.js'], true).then(() => {
        //         Helpers.setLoading(false);
        //         LoginCustom.init();
        //     });
    }

    backLogin() {
        this._router.navigate(['/login']);
    }
    signin() {
        this.error = '';
        Helpers.setLoading(true);
        this._authService.forgot(this.model.email).subscribe();
        this.istrue = false;
        this.isrequest = true;
        Helpers.setLoading(false);
    }
}


// WEBPACK FOOTER //
// D:/FMFB/FMFB Dashboard/src/app/auth/forgot.component.ts